/**
 * API/WebSocket configuration for AI UI
 */

// Use the same pattern as the main frontend: host from env + /api suffix
const API_BASE_URL = `${import.meta.env.VITE_API_BASE_URL || ''}/api`;
const API_ORIGIN_FOR_WS =
    import.meta.env.VITE_API_BASE_URL || import.meta.env.VITE_APP_API_URL || '';

// Derive WebSocket base URL from API_BASE_URL or window location
function deriveWsBase() {
    // Check for explicit WS URL env var
    const envWs = import.meta.env.VITE_WS_BASE_URL || '';
    if (envWs && typeof envWs === 'string' && envWs.length > 0) {
        return envWs.replace(/\/$/, '');
    }

    // Try to derive from the configured backend origin
    if (API_ORIGIN_FOR_WS) {
        try {
            const url = new URL(API_ORIGIN_FOR_WS);
            const proto = url.protocol === 'https:' ? 'wss:' : 'ws:';
            return `${proto}//${url.host}`;
        } catch {
            // ignore and fallback
        }
    }

    // Fallback to window location
    if (typeof window !== 'undefined') {
        const proto = window.location.protocol === 'https:' ? 'wss:' : 'ws:';
        return `${proto}//${window.location.host}`;
    }

    return '';
}

const WS_BASE_URL = deriveWsBase();

export { API_BASE_URL, WS_BASE_URL };
export default API_BASE_URL;
